import {
  fillMemorialDocx,
  downloadMemorialDocxFile,
} from "@/utils/memorialDocx";

function parseApiErrorBody(text) {
  if (!text) return text;
  try {
    const json = JSON.parse(text);
    if (typeof json === "string") return json;
    return json.message || json.error || text;
  } catch {
    return text;
  }
}

/**
 * Baixa o modelo .docx e preenche no navegador (preserva formatação do Word).
 */
export async function generateBudgetDocxFromServer({
  baseUrl,
  budgetId,
  token,
}) {
  const base = (baseUrl || "").replace(/\/?$/, "/");
  const dataUrl = base + "user/budgets/" + budgetId + "/data";
  const templateUrl = base + "user/budgets/" + budgetId + "/template";

  const authHeaders = {
    Accept: "application/json",
    Authorization: "Bearer " + token,
  };

  const dataRes = await fetch(dataUrl, { headers: authHeaders });
  if (!dataRes.ok) {
    const errText = await dataRes.text();
    throw new Error(
      "Não foi possível obter os dados do orçamento: " +
        (parseApiErrorBody(errText) || dataRes.status)
    );
  }

  const json = await dataRes.json();
  const fields = json.fields;
  if (!fields || typeof fields !== "object") {
    throw new Error("Resposta inválida da API (faltou fields).");
  }
  if (json.hasTemplate === false) {
    throw new Error(
      "Modelo de orçamento não configurado. Envie o .docx em Configurações → Orçamento."
    );
  }

  const version = json.templateVersion || Date.now();
  const tplRes = await fetch(templateUrl + "?v=" + version, {
    headers: { Authorization: "Bearer " + token },
    cache: "no-store",
  });
  if (!tplRes.ok) {
    const errText = await tplRes.text();
    throw new Error(
      "Não foi possível carregar o modelo .docx: " +
        (parseApiErrorBody(errText) || tplRes.status)
    );
  }

  const buf = await tplRes.arrayBuffer();

  const blockFields = {};
  const kitWordXml = json.kitWordXml;
  if (kitWordXml && String(kitWordXml).trim()) {
    blockFields["$kit"] = String(kitWordXml);
  }
  const kitDescricaoWordXml = json.kitDescricaoWordXml;
  if (kitDescricaoWordXml && String(kitDescricaoWordXml).trim()) {
    blockFields["$kit_descricao"] = String(kitDescricaoWordXml);
  }

  const blob = fillMemorialDocx(buf, fields, { blockFields });
  return { blob, budgetName: json.budgetName || "" };
}

export function downloadBudgetDocxFile(blob, budgetName, budgetId) {
  const safeName = String(budgetName || "orcamento")
    .replace(/[^a-zA-Z0-9\-_. ]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .trim();
  const filename = (safeName || "orcamento") + "-" + budgetId + ".docx";
  downloadMemorialDocxFile(blob, filename);
}

export async function generateAndDownloadBudgetDocx(options) {
  const { blob, budgetName } = await generateBudgetDocxFromServer(options);
  downloadBudgetDocxFile(blob, budgetName, options.budgetId);
}
